<template>
  <div class="afdc-row afdc-ev-levels-with-question">
    <div class="afdc-col-md-6">
      <label class ="afdc-col-form-label" for="afdc-find-ev-levels">{{ $t("Charger Types") }}</label>
      <select-multiple-dropdown v-model="queryEvLevels" v-bind:options="levelOptions" id="afdc-find-ev-levels"/>
    </div>

    <div class="afdc-col-md-6">
      <label class="afdc-col-form-label" for="afdc-find-ev-connectors">{{ $t("Connectors") }}</label>
      <select-multiple-dropdown v-model="queryEvConnectors" v-bind:options="connectorOptions" id="afdc-find-ev-connectors"/>
    </div>

    <a href="#" v-on:click.prevent="toggleEvHelp" class="afdc-ev-level-question" v-bind:aria-label="$t('Help')"><font-awesome-icon icon="question-circle" class="afdc-fa-icon afdc-ev-level-question-icon"/></a>
  </div>
</template>

<script>
import SelectMultipleDropdown from '@/components/SelectMultipleDropdown.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  components: {
    SelectMultipleDropdown,
  },
  data() {
    return {
      uniqueId: null,
    };
  },

  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.uniqueId = this._uid;
  },

  computed: {
    queryEvLevels: syncInputRouteQuery('ev_levels'),
    queryEvConnectors: syncInputRouteQuery('ev_connectors'),
    levelOptions() {
      const options = this.$store.getters.loaderElecLevels;
      return options.filter((option) => option.key !== 'legacy');
    },

    evLevelOptions() {
      return this.$store.getters.loaderElecLevels.filter((level) => (level.key === '1' || level.key === '2'));
    },

    connectorOptions() {
      const connectors = this.$store.getters.loaderElecConnectors;
      const options = [];
      connectors.forEach((connector) => {
        // exclude Level 1 connectors
        if (!connector.level || connector.level.key !== '1') {
          options.push({
            key: connector.key,
            name: connector.name,
          });
        }
      });
      return options;
    },

    evConnectorOptions() {
      return this.$store.getters.loaderElecConnectors.filter((connector) => (connector.level && connector.level.key === 'dc_fast'));
    },
  },

  methods: {
    toggleEvHelp() {
      this.$store.commit('setEvHelpClicked', true);

      const content = document.getElementById('afdc-ev-level-help');

      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

.ev-levels-with-question {
  position: relative;
  width: auto;

  .col-md-6 strong {
    font-size: 14px;
    margin-top: 10px;
  }
}

.ev-level-question {
  position: absolute;
  top: -15px;
  right: 0px;
  color: inherit;
  font-size: 20px;
  &:hover {
    color: #444;
    opacity: .5;
  }
}
</style>
